export const companyHostDeviceTitle = {
  type: 'string',
  minLength: 1,
  maxLength: 255,
};
